import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/contexts/AuthContext";
import { useTheme } from "@/themes/themes";

export default function WelcomePage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { theme } = useTheme();
  const firstName = user?.user_metadata?.full_name?.split(' ')[0] || '';

  const bgStyle = {
    backgroundImage: `
      radial-gradient(ellipse at center, transparent 0%, transparent 40%, rgba(0,0,0,0.12) 100%),
      url(${theme.backgroundImage || '/assets/Smooth_blue_gradient_backdrop.png'})
    `,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: theme.background,
  };

  const handleGetStarted = () => {
    navigate('/intro');
  };

  return (
    <div className="havn-container" style={bgStyle} data-testid="welcome-page">
      <main className="flex flex-col items-center justify-center flex-1 z-10 gap-16 px-6">
        {/* HAVN Wordmark */}
        <motion.img
          src="/havn-logo-white.png"
          alt="HAVN"
          style={{ height: '8vh', minHeight: '36px', maxHeight: '52px', width: 'auto', objectFit: 'contain' }}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          data-testid="welcome-wordmark"
        />

        {/* Tagline */}
        <motion.p
          className="text-[var(--sidekick-text-secondary)] text-lg sm:text-xl text-center max-w-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          {firstName ? `Welcome, ${firstName}!` : 'Your calm, trusted digital companion.'}
        </motion.p>

        {/* Get Started Button */}
        <motion.button
          onClick={handleGetStarted}
          className="px-10 py-4 bg-[var(--sidekick-primary)] text-[var(--sidekick-primary-foreground)] 
                     font-semibold text-lg rounded-full shadow-lg
                     hover:opacity-90 active:scale-95 transition-all duration-200
                     focus:outline-none focus:ring-2 focus:ring-[var(--sidekick-primary)] focus:ring-offset-2 focus:ring-offset-[var(--sidekick-bg)]"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.6 }}
          data-testid="get-started-button"
        >
          Get started
        </motion.button>
      </main>
    </div>
  );
}
